// TOOD actually implement or delete

import useMutationApi from 'src/api/useMutationApi';

interface RequestBody {
  index: number;
}

const useDeleteSalesOrderDraftLineItem = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
  onError?: () => void,
) => {
  return useMutationApi<RequestBody>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/line-items`,
    method: 'DELETE',
    options: {
      onSuccess,
      onError,
    },
  });
};

export default useDeleteSalesOrderDraftLineItem;
